<template>
  <CustomDialog ref='confirm' :element='dialog.element.eleConfirm' :styles='dialog.styles'>
    <template v-slot:dialog-content>
      <div ref='confirmContent' style="display: block; text-align: left; font-size: 16px; ">
        <span >
          {{content}}
        </span>
      </div>
    </template>
  </CustomDialog>
</template>

<script>
import CustomDialog from '../../../common/CustomDialog';

export default {
  name: "DialogConfirm",
  components: {
    CustomDialog,
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    onOk: {
      type: Function,
      default: undefined
    },
    onCancel: {
      type: Function,
      default: undefined
    },
  },
  data() {
    return {
      dialog: {
        styles: {
          width: "400px",
          height: "240px",
          visible: false,
          model: true
        },
        element: {
          eleConfirm: {
            target: this.$refs.confirmContent,
            refName: "eleConfirm",
            buttonGroup: [
              { click: this.cancel, buttonModel: { content: this.$t('SubscriberIms.cancel') } },
              {
                click: this.ok,
                buttonModel: { content:  this.$t('SubscriberIms.confirm'), isPrimary: true }
              }
            ],
            title: this.title || '',
            isClose: true,
            isModal: true,
          }
        },
      }
    };
  },
  methods: {
    show() {
      this.$refs.confirm.show();
    },
    ok() {
      if(this.onOk) {
        this.onOk();
      }
      this.$refs.confirm.close();
    },
    cancel() {
      if(this.onCancel) {
        this.onCancel();
      }
      this.$refs.confirm.close();
    }
  }
};
</script>

<style scoped>
</style>
